function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e11) { throw _e11; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e12) { didErr = true; err = _e12; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("effector")) : "function" == typeof define && define.amd ? define(["exports", "effector"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).patronum = {}, e.effector);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return e && "object" == _typeof(e) && "default" in e ? e : {
      default: e
    };
  }

  var r = n(t);

  function o(e, t, n) {
    return e(n = {
      path: t,
      exports: {},
      require: function require(e, t) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == t && n.path);
      }
    }, n.exports), n.exports;
  }

  var a = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.and = function () {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      return (0, r.default.combine)({
        and: [e, function (e) {
          var _iterator = _createForOfIteratorHelper(e),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t = _step.value;
              if (!_t) return !1;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return !0;
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-rbm5ks"
        }
      });
    };
  }),
      i = o(function (e, t) {
    function n(e) {
      throw new Error(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.combineEvents = function (e) {
      var t = function (e) {
        return Object.keys(e).some(function (t) {
          return !["events", "reset", "target"].includes(t) && r.default.is.unit(e[t]);
        });
      }(e) ? {
        events: e
      } : e,
          o = t.events,
          a = t.reset,
          _t$target = t.target,
          i = _t$target === void 0 ? (0, r.default.createEvent)({
        name: "target",
        sid: "p73fff"
      }) : _t$target;
      r.default.is.unit(i) && r.default.is.targetable(i) || n("target should be a targetable unit");
      a && !r.default.is.unit(a) && n("reset should be a unit");
      return (0, r.default.withRegion)(i, function () {
        var e = Object.keys(o),
            t = Array.isArray(o) ? _toConsumableArray(e).fill("") : {},
            n = (0, r.default.createStore)(e.length, {
          and: {
            serialize: "ignore"
          },
          name: "$counter",
          sid: "-ahoahx"
        }),
            s = (0, r.default.createStore)(t, {
          and: {
            serialize: "ignore"
          },
          name: "$results",
          sid: "oy8iyn"
        });
        (0, r.default.sample)({
          and: [{
            source: i,
            target: n.reinit
          }],
          or: {
            sid: "blex0c"
          }
        }), s.reset(i), a && ((0, r.default.sample)({
          and: [{
            source: a,
            target: n.reinit
          }],
          or: {
            sid: "bnm3fi"
          }
        }), s.reset(a));

        var _loop = function _loop() {
          var t = _e[_i];
          var e = (0, r.default.createStore)(!1, {
            and: {
              serialize: "ignore"
            },
            name: "$isDone",
            sid: "-rf2fac"
          }).on(o[t], function () {
            return !0;
          }).reset(i);
          a && e.reset(a), n.on(e, function (e) {
            return e - 1;
          }), s.on(o[t], function (e, n) {
            var r = Array.isArray(e) ? _toConsumableArray(e) : _objectSpread({}, e);
            return r[t] = n, r;
          });
        };

        for (var _i = 0, _e = e; _i < _e.length; _i++) {
          _loop();
        }

        var u = (0, r.default.sample)({
          and: [{
            source: s,
            clock: _toConsumableArray(Object.values(o))
          }],
          or: {
            name: "eventsTrriggered",
            sid: "-lro8bq"
          }
        });
        (0, r.default.sample)({
          and: [{
            source: u,
            filter: n.map(function (e) {
              return 0 === e;
            }, {
              skipVoid: !1
            }),
            target: i
          }],
          or: {
            sid: "-dlkr2s"
          }
        });
      }), i;
    };
  }),
      s = o(function (e, t) {
    function n(e) {
      return r.default.is.unit(e) ? e.map(function (e) {
        return !e;
      }, {
        skipVoid: !1
      }) : function (t) {
        return !e(t);
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.condition = function (_ref) {
      var e = _ref.if,
          t = _ref.then,
          o = _ref.else,
          _ref$source = _ref.source,
          a = _ref$source === void 0 ? (0, r.default.createEvent)({
        name: "source",
        sid: "tdyoa4"
      }) : _ref$source;
      var i = r.default.is.unit(e) || (s = e, "function" == typeof s) ? e : function (t) {
        return t === e;
      };
      var s;
      t && o ? (0, r.default.split)({
        and: [{
          source: a,
          match: {
            then: i,
            else: n(i)
          },
          cases: {
            then: t,
            else: o
          }
        }],
        or: {
          sid: "aaw2hr"
        }
      }) : t ? (0, r.default.sample)({
        and: [{
          source: a,
          filter: i,
          target: t
        }],
        or: {
          sid: "-dwrmbb"
        }
      }) : o && (0, r.default.sample)({
        and: [{
          source: a,
          filter: n(i),
          target: o
        }],
        or: {
          sid: "-dsx25s"
        }
      });
      return a;
    };
  }),
      u = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.debounce = function () {
      var t;
      var n = 2 === arguments.length ? {
        source: arguments.length <= 0 ? undefined : arguments[0],
        timeout: arguments.length <= 1 ? undefined : arguments[1]
      } : arguments.length <= 0 ? undefined : arguments[0],
          o = n.source,
          a = n.timeout,
          i = n.target,
          s = n.name;
      if (!r.default.is.unit(o)) throw new TypeError("source must be unit from effector");
      if (r.default.is.domain(o, {
        sid: "jsc7s2"
      })) throw new TypeError("source cannot be domain");

      var u = function (e) {
        if (r.default.is.store(e, {
          sid: "-21qm2b"
        })) return e;

        if ("number" == typeof e) {
          if (e < 0 || !Number.isFinite(e)) throw new Error("timeout must be positive number or zero. Received: \"".concat(e, "\""));
          return (0, r.default.createStore)(e, {
            and: {
              name: "$timeout"
            },
            sid: "kbepy4"
          });
        }

        throw new TypeError("timeout parameter in interval method should be number or Store. \"".concat(_typeof(e), "\" was passed"));
      }(a),
          d = (0, r.default.createEvent)({
        name: "saveCancel",
        sid: "-kec0n3"
      }),
          c = (0, r.default.createStore)([], {
        and: {
          serialize: "ignore"
        },
        name: "$canceller",
        sid: "-tfm9fg"
      }).on(d, function (e, t) {
        return t;
      }),
          l = null !== (t = i) && void 0 !== t ? t : (0, r.default.createEvent)({
        name: "tick",
        sid: "-50e2rn"
      }),
          f = (0, r.default.attach)({
        and: {
          name: s || "debounce(".concat((o === null || o === void 0 ? void 0 : o.shortName) || o.kind, ") effect"),
          source: c,
          effect: function effect(_ref2, n) {
            var _ref3 = _slicedToArray(_ref2, 2),
                e = _ref3[0],
                t = _ref3[1];

            return e && clearTimeout(e), t && t(), new Promise(function (e, t) {
              d([setTimeout(e, n), t]);
            });
          }
        },
        or: {
          name: "timerFx",
          sid: "-jwso4j"
        }
      });

      c.reset(f.done);
      var m = (0, r.default.createStore)([], {
        and: {
          serialize: "ignore",
          skipVoid: !1
        },
        name: "$payload",
        sid: "-x9cllg"
      }).on(o, function (e, t) {
        return [t];
      }),
          p = (0, r.default.createStore)(!0, {
        and: {
          serialize: "ignore"
        },
        name: "$canTick",
        sid: "8r2952"
      }),
          y = (0, r.default.createEvent)({
        name: "triggerTick",
        sid: "-781myl"
      });
      p.on(y, function () {
        return !1;
      }).on([l, u, f], function () {
        return !0;
      });
      var g = (0, r.default.merge)([o, (0, r.default.sample)({
        and: [{
          clock: u,
          filter: f.pending
        }],
        or: {
          name: "requestTick",
          sid: "-khrpxp"
        }
      })], {
        name: "requestTick",
        sid: "2k0852"
      });
      return (0, r.default.sample)({
        and: [{
          clock: g,
          filter: p,
          target: y
        }],
        or: {
          sid: "-31h8q8"
        }
      }), (0, r.default.sample)({
        and: [{
          source: u,
          clock: y,
          target: f
        }],
        or: {
          sid: "-2y6h62"
        }
      }), (0, r.default.sample)({
        and: [{
          source: m,
          clock: f.done,
          fn: function fn(_ref4) {
            var _ref5 = _slicedToArray(_ref4, 1),
                e = _ref5[0];

            return e;
          },
          target: l
        }],
        or: {
          sid: "-2jc15b"
        }
      }), l;
    };
  }),
      d = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.debug = o;
    var n = {
      trace: !1,
      handler: function handler(e) {
        if (g(e.node) && "finally" === e.node.meta.named) return;
        var t = e.scope,
            n = e.scopeName,
            r = e.name,
            o = e.kind,
            a = e.value,
            i = e.loc,
            s = e.trace,
            u = e.node,
            d = e.logType,
            c = t ? " (scope: ".concat(n, ")") : "",
            l = null != r ? r : i ? "".concat(i.file, ":").concat(i.line, ":").concat(i.column) : "",
            f = "initial" === d ? " [getState]" : "";
        console.info("[".concat(o, "]").concat(c, " ").concat(l).concat(f), a), s && s.length > 0 && !g(u) && (console.groupCollapsed("[".concat(o, "]").concat(c, " ").concat(l, " trace")), s.forEach(function (e) {
          var t = e.name,
              n = e.kind,
              r = e.value,
              o = e.loc,
              a = null != t ? t : o ? "".concat(o.file, ":").concat(o.line, ":").concat(o.column) : "";
          console.info("<- [".concat(n, "] ").concat(a), r);
        }), console.groupEnd());
      }
    };

    function o() {
      var _ref6 = function () {
        var t = n;

        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }

        var o = e[0],
            a = e.slice(1),
            i = [];
        if (function (e) {
          if (!r.default.is.unit(e)) return !Object.values(e).every(r.default.is.unit);
          return !1;
        }(o)) t = _objectSpread(_objectSpread({}, n), o);else if (r.default.is.unit(o)) i.push(o);else for (var _i2 = 0, _Object$entries = Object.entries(o); _i2 < _Object$entries.length; _i2++) {
          var _ref9 = _Object$entries[_i2];

          var _ref8 = _slicedToArray(_ref9, 2);

          var _e2 = _ref8[0];
          var _t2 = _ref8[1];
          v.set(b(_t2).id, _e2), i.push(_t2);
        }

        var _iterator2 = _createForOfIteratorHelper(a),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e3 = _step2.value;
            if (r.default.is.unit(_e3)) i.push(_e3);else for (var _i3 = 0, _Object$entries2 = Object.entries(_e3); _i3 < _Object$entries2.length; _i3++) {
              var _ref12 = _Object$entries2[_i3];

              var _ref11 = _slicedToArray(_ref12, 2);

              var _t3 = _ref11[0];
              var _n2 = _ref11[1];
              v.set(b(_n2).id, _t3), i.push(_n2);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return {
          config: t,
          units: i
        };
      }.apply(void 0, arguments),
          t = _ref6.config,
          o = _ref6.units;

      o.forEach(function (e) {
        r.default.is.store(e, {
          sid: "-foynff"
        }) || r.default.is.event(e, {
          sid: "apy28p"
        }) || r.default.is.effect(e, {
          sid: "apy3od"
        }) ? i(e, t) : r.default.is.domain(e, {
          sid: "-rsqe9t"
        }) && a(e, t);
      });
    }

    function a(e, t) {
      e.onCreateStore(function (e) {
        return i(e, t);
      }), e.onCreateEvent(function (e) {
        return i(e, t);
      }), e.onCreateEffect(function (e) {
        return i(e, t);
      }), e.onCreateDomain(function (e) {
        return a(e, t);
      });
    }

    function i(e, t) {
      r.default.is.store(e, {
        sid: "w7ds2s"
      }) ? (!function (e, t) {
        if (!t.handler) throw Error("patronum/debug must have the handler");
        var n = {
          logType: "initial",
          scope: null,
          scopeName: null,
          node: _(e),
          kind: h(e),
          value: e.getState(),
          name: k(e),
          loc: j(e),
          trace: [],
          stackMeta: {}
        };
        t.handler(n), p.forEach(function (n) {
          return d(e, t, n);
        }), l(function (n) {
          return d(e, t, n);
        });
      }(e, t), s(e, t)) : r.default.is.event(e, {
        sid: "fretyd"
      }) ? s(e, t) : r.default.is.effect(e, {
        sid: "gpi2qr"
      }) && (s(e, t), s(e.finally, t), s(e.done, t), s(e.fail, t));
    }

    function s(e, t) {
      var n = (0, r.default.createNode)({
        parent: [e],
        meta: {
          op: "watch"
        },
        family: {
          owners: e
        },
        regional: !0,
        node: [r.default.step.run({
          fn: function fn(n, r, o) {
            var a;
            var i = null !== (a = o === null || o === void 0 ? void 0 : o.scope) && void 0 !== a ? a : null,
                s = {
              logType: "update",
              scope: i,
              scopeName: y(i),
              node: _(e),
              kind: h(e),
              value: n,
              name: k(e),
              loc: j(e),
              stackMeta: $(o.parent),
              trace: t.trace ? u(o) : []
            };
            if (!t.handler) throw Error("patronum/debug must have the handler");
            t.handler(s);
          }
        })]
      });
      return function () {
        return (0, r.default.clearNode)(n);
      };
    }

    function u(e) {
      var t = [];
      var n = e === null || e === void 0 ? void 0 : e.parent;

      for (; n;) {
        var _n3 = n,
            _e4 = _n3.node,
            _r = _n3.value,
            _o = {
          node: _e4,
          value: _r,
          name: k(_e4),
          loc: j(_e4),
          kind: h(_e4),
          stackMeta: $(n)
        };
        t.push(_o), n = n.parent;
      }

      return t;
    }

    function d(e, t, n) {
      if (!t.handler) throw Error("patronum/debug must have the handler");

      var r = _(e),
          o = {
        logType: "initial",
        scope: n,
        scopeName: y(n),
        node: r,
        kind: h(e),
        value: n.getState(e),
        name: k(e),
        loc: j(e),
        trace: [],
        stackMeta: {}
      };

      t.handler(o);
    }

    var c = new Set(),
        l = function l(e) {
      return c.add(e), function () {
        c.delete(e);
      };
    };

    var f = 0;
    var m = new Map(),
        p = {
      save: function save(e, t) {
        p.get(e) || m.set(e, t);
      },
      get: function get(e) {
        var t;
        return e && null !== (t = m.get(e)) && void 0 !== t ? t : null;
      },
      delete: function _delete(e) {
        m.delete(e);
      },
      forEach: function forEach(e) {
        m.forEach(function (t, n) {
          return e(n, t);
        });
      },
      clear: function clear() {
        m.clear();
      }
    };

    function y(e) {
      if (!e) return null;
      var t = p.get(e);

      if (!t) {
        return e._debugId || (e._debugId = (f += 1, "unknown_".concat(f)));
      }

      return t.name;
    }

    function g(e) {
      var t = _(e),
          _t$meta = t.meta,
          n = _t$meta.sid,
          r = _t$meta.named;

      return Boolean(!n && ("finally" === r || "done" === r || "doneData" === r || "fail" === r || "failData" === r || "inFlight" === r || "pending" === r));
    }

    function h(e) {
      if (r.default.is.store(e, {
        sid: "4o7s04"
      })) return "store";
      if (r.default.is.effect(e, {
        sid: "4pv5s7"
      }) || g(e)) return "effect";
      if (r.default.is.event(e, {
        sid: "4rijka"
      })) return "event";
      if (r.default.is.domain(e, {
        sid: "54plsy"
      })) return "domain";
      if (r.default.is.unit(e)) return "unit";

      var t = _(e);

      return t.meta.op ? t.meta.op : "unknown";
    }

    o.registerScope = function (e, t) {
      return p.save(e, {
        name: t.name
      }), c.forEach(function (t) {
        return t(e);
      }), function () {
        p.delete(e);
      };
    }, o.unregisterAllScopes = function () {
      p.clear();
    };

    var b = function b(e) {
      return e.graphite || e;
    },
        v = new Map();

    function k(e) {
      var _ref13, _ref13$meta;

      var t = v.get(b(e).id);
      if (t) return t;

      if (g(e)) {
        var _t4 = _(e),
            _n4 = _t4.family.owners.find(function (e) {
          return "effect" === e.meta.op;
        });

        if (_n4) {
          var _e5 = w(_n4);

          return "".concat(_e5 ? "".concat(_e5, "/") : "").concat(k(_n4), ".").concat(_t4.meta.named);
        }

        return _t4.meta.named;
      }

      if (function (e) {
        var t = _(e),
            n = t.meta.op;

        return "on" === n;
      }(e)) {
        var _t5 = _(e);

        return "".concat(k(_t5.next[0]), ".on(").concat(k(_t5.family.owners[0]), ")");
      }

      if (r.default.is.unit(e)) {
        var _e$compositeName;

        if (e !== null && e !== void 0 && (_e$compositeName = e.compositeName) !== null && _e$compositeName !== void 0 && _e$compositeName.fullName) return e.compositeName.fullName;

        var _t6 = w(e),
            _n5 = _t6 ? "".concat(_t6, "/") : "";

        if (e !== null && e !== void 0 && e.shortName) return "".concat(_n5).concat(e.shortName);
        if (e !== null && e !== void 0 && e.name) return "".concat(_n5).concat(e.name);
      }

      return (_ref13 = _(e)) !== null && _ref13 !== void 0 && (_ref13$meta = _ref13.meta) !== null && _ref13$meta !== void 0 && _ref13$meta.name ? _(e).meta.name : null;
    }

    function w(e) {
      var t = _(e).family.owners.find(function (e) {
        return "domain" === e.meta.op;
      });

      return t ? k(t) : null;
    }

    function j(e) {
      var t = function (_ref14) {
        var e = _ref14.meta;
        return "config" in e ? e.config.loc : e.loc;
      }(_(e));

      if (t) return t;
    }

    function _(e) {
      return "graphite" in e ? e.graphite : e;
    }

    function $(e) {
      if (!e) return {};
      return e.meta || {};
    }
  }),
      c = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.delay = function () {
      var t = 2 === arguments.length ? {
        source: arguments.length <= 0 ? undefined : arguments[0],
        timeout: arguments.length <= 1 ? undefined : arguments[1]
      } : arguments.length <= 0 ? undefined : arguments[0],
          n = t.source,
          o = t.timeout,
          _t$target2 = t.target,
          a = _t$target2 === void 0 ? (0, r.default.createEvent)({
        name: "target",
        sid: "jucb8d"
      }) : _t$target2,
          i = Array.isArray(a) ? a : [a];
      if (!r.default.is.unit(n)) throw new TypeError("source must be a unit from effector");
      if (!i.every(function (e) {
        return r.default.is.unit(e);
      })) throw new TypeError("target must be a unit from effector");

      var s = function (e) {
        if (r.default.is.store(e, {
          sid: "-tvk3f2"
        }) || "function" == typeof e || "number" == typeof e) return e;
        throw new TypeError("'timeout' argument must be a function, Store, or a number. Passed \"".concat(_typeof(e), "\""));
      }(o),
          u = (0, r.default.createEffect)(function (_ref15) {
        var e = _ref15.payload,
            t = _ref15.milliseconds;
        return new Promise(function (n) {
          setTimeout(n, t, e);
        });
      }, {
        name: "timerFx",
        sid: "-wp3hwr"
      });

      return (0, r.default.sample)({
        and: [{
          source: (0, r.default.combine)({
            and: [{
              milliseconds: s
            }],
            or: {
              name: "source",
              sid: "-gaikyz"
            }
          }),
          clock: n,
          fn: function fn(_ref16, t) {
            var e = _ref16.milliseconds;
            return {
              payload: t,
              milliseconds: "function" == typeof e ? e(t) : e
            };
          },
          target: u
        }],
        or: {
          sid: "-uuqxfw"
        }
      }), (0, r.default.sample)({
        and: [{
          clock: u.doneData,
          target: i
        }],
        or: {
          sid: "-uc1x9m"
        }
      }), a;
    };
  }),
      l = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.either = function e(t, n, o) {
      if (r.default.is.store(t, {
        sid: "ozzvoc"
      })) return (0, r.default.combine)({
        and: [t, n, o, function (e, t, n) {
          return e ? t : n;
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-5vau2h"
        }
      });
      var a = t;
      return e(a.filter, a.then, a.other);
    };
  }),
      f = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.empty = function (e) {
      return e.map(function (e) {
        return null == e;
      }, {
        skipVoid: !1
      });
    };
  }),
      m = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.equals = function (e, t) {
      return (0, r.default.combine)({
        and: [e, t, function (e, t) {
          return e === t;
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-pqjlti"
        }
      });
    };
  }),
      p = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.every = function (e, t) {
      var n,
          o = [],
          a = function a() {
        return !1;
      };

      Array.isArray(e) ? (o = e, a = t) : Array.isArray(e.stores) && (o = e.stores, a = e.predicate);
      i = a, n = "function" == typeof i ? a : r.default.is.store(a, {
        sid: "sid3ut"
      }) ? a.map(function (e) {
        return function (t) {
          return e === t;
        };
      }, {
        skipVoid: !1
      }) : function (e) {
        return e === a;
      };
      var i;
      var s = (0, r.default.combine)({
        and: [o],
        or: {
          name: "$values",
          sid: "rwb5jx"
        }
      }),
          u = n;
      return (0, r.default.combine)({
        and: [u, s, function (e, t) {
          return t.every(e);
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "hgnz2z"
        }
      });
    };
  }),
      y = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.format = function (e) {
      for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        t[_key3 - 1] = arguments[_key3];
      }

      return (0, r.default.combine)({
        and: [t, function (t) {
          return e.reduce(function (n, r, o) {
            return n.concat(function (e, t) {
              return t === e.length - 1;
            }(e, o) ? r : "".concat(r).concat(function (e) {
              if (Array.isArray(e)) return e.map(function (e) {
                return String(e);
              }).join(", ");
              return String(e);
            }(t[o])));
          }, "");
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-yrbthp"
        }
      });
    };
  }),
      g = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.inFlight = function (e) {
      var t = Array.isArray(e) ? {
        effects: e
      } : e,
          n = t.effects,
          o = t.domain;

      if (o) {
        var _e6 = o.createStore(0, {
          name: "$inFlight",
          sid: "-wboyn1"
        });

        return o.onCreateEffect(function (t) {
          _e6.on(t, function (e) {
            return e + 1;
          }).on(t.finally, function (e) {
            return e - 1;
          });
        }), _e6;
      }

      return (0, r.default.combine)({
        and: [n.map(function (e) {
          return e.inFlight;
        }), function (e) {
          return e.reduce(function (e, t) {
            return e + t;
          }, 0);
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "udy3nn"
        }
      });
    };
  }),
      h = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.interval = function (_ref17) {
      var e = _ref17.timeout,
          t = _ref17.start,
          n = _ref17.stop,
          _ref17$leading = _ref17.leading,
          o = _ref17$leading === void 0 ? !1 : _ref17$leading,
          _ref17$trailing = _ref17.trailing,
          a = _ref17$trailing === void 0 ? !1 : _ref17$trailing;
      var i = (0, r.default.createEvent)({
        name: "setup",
        sid: "-ajee8b"
      });
      t && (0, r.default.sample)({
        and: [{
          clock: t,
          target: i
        }],
        or: {
          sid: "-wq30tc"
        }
      });
      var s = (0, r.default.createEvent)({
        name: "teardown",
        sid: "-on6wf8"
      });
      n && (0, r.default.sample)({
        and: [{
          clock: n,
          target: s
        }],
        or: {
          sid: "-wloo2g"
        }
      });

      var u = (0, r.default.createEvent)({
        name: "tick",
        sid: "37avek"
      }),
          d = (0, r.default.createStore)(!1, {
        name: "$isRunning",
        sid: "amqfro"
      }),
          c = function (e) {
        if (r.default.is.store(e, {
          sid: "90rxd3"
        })) return e;
        if ("number" == typeof e) return (0, r.default.createStore)(e, {
          and: {
            name: "$timeout"
          },
          sid: "-3ibdj9"
        });
        throw new TypeError("timeout parameter in interval method should be number or Store. \"".concat(_typeof(e), "\" was passed"));
      }(e),
          l = d.map(function (e) {
        return !e;
      }, {
        skipVoid: !1
      }),
          f = (0, r.default.createEvent)({
        name: "saveTimeout",
        sid: "-goth3o"
      }),
          m = (0, r.default.createStore)(null, {
        name: "$timeoutId",
        sid: "xi134t"
      }).on(f, function (e, _ref18) {
        var t = _ref18.timeoutId;
        return t;
      }),
          p = (0, r.default.createStore)(function () {}, {
        name: "$rejecter",
        sid: "-2am6sk"
      }).on(f, function (e, _ref19) {
        var t = _ref19.reject;
        return t;
      }),
          y = (0, r.default.attach)({
        and: {
          source: {
            timeout: c,
            running: d
          },
          effect: function effect(_ref20) {
            var e = _ref20.timeout,
                t = _ref20.running;
            return t ? new Promise(function (t, n) {
              var r = setTimeout(t, e);
              f({
                timeoutId: r,
                reject: n
              });
            }) : Promise.reject();
          }
        },
        or: {
          name: "timeoutFx",
          sid: "-hiem3q"
        }
      }),
          g = (0, r.default.attach)({
        and: {
          source: {
            timeoutId: m,
            rejecter: p
          },
          effect: function effect(_ref21) {
            var e = _ref21.timeoutId,
                t = _ref21.rejecter;
            t(), e && clearTimeout(e);
          }
        },
        or: {
          name: "cleanupFx",
          sid: "d148gq"
        }
      });

      if ((0, r.default.sample)({
        and: [{
          clock: i,
          source: c,
          filter: l,
          target: y
        }],
        or: {
          sid: "-u9k5bx"
        }
      }), o) {
        var _e7 = (0, r.default.sample)({
          and: [{
            clock: i,
            filter: l
          }],
          or: {
            name: "onReady",
            sid: "5o8c6v"
          }
        });

        (0, r.default.sample)({
          and: [{
            clock: _e7,
            target: u
          }],
          or: {
            sid: "6njtce"
          }
        });
      }

      (0, r.default.sample)({
        and: [{
          clock: i,
          fn: function fn() {
            return !0;
          },
          target: d
        }],
        or: {
          sid: "6p772r"
        }
      }), (0, r.default.sample)({
        and: [{
          clock: y.done,
          source: c,
          filter: d,
          target: y
        }],
        or: {
          sid: "741n3i"
        }
      }), (0, r.default.sample)({
        and: [{
          clock: y.done,
          filter: d,
          target: u.prepend(function () {})
        }],
        or: {
          sid: "7jfvpm"
        }
      }), a && (0, r.default.sample)({
        and: [{
          clock: s,
          target: u
        }],
        or: {
          sid: "7zxpk6"
        }
      });
      return d.on(s, function () {
        return !1;
      }), (0, r.default.sample)({
        and: [{
          clock: s,
          target: g
        }],
        or: {
          sid: "84c29c"
        }
      }), {
        tick: u,
        isRunning: d,
        "@@trigger": function trigger() {
          return {
            setup: i,
            teardown: s,
            fired: u
          };
        }
      };
    };
  }),
      b = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.not = function (e) {
      return e.map(function (e) {
        return !e;
      }, {
        skipVoid: !1
      });
    };
  }),
      v = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.once = function (e) {
      var _e8;

      var t, n;
      r.default.is.unit(e) ? t = e : (_e8 = e, t = _e8.source, n = _e8.reset, _e8);
      var o = (0, r.default.createStore)(!0, {
        name: "$canTrigger",
        sid: "ys2jl0"
      }),
          a = (0, r.default.sample)({
        and: [{
          source: t,
          filter: o
        }],
        or: {
          name: "trigger",
          sid: "e3xto3"
        }
      });
      o.on(a, function () {
        return !1;
      }), n && o.reset(n);
      return a;
    };
  }),
      k = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.or = function () {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      return (0, r.default.combine)({
        and: [e, function (e) {
          var _iterator3 = _createForOfIteratorHelper(e),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t7 = _step3.value;
              if (_t7) return !0;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return !1;
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-44722k"
        }
      });
    };
  }),
      w = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.pending = function (e) {
      var t = Array.isArray(e) ? {
        effects: e
      } : e,
          o = t.effects,
          a = t.domain,
          _t$of = t.of,
          i = _t$of === void 0 ? "some" : _t$of;
      if (!r.default.is.domain(a, {
        sid: "98ymuf"
      }) && !o) throw new TypeError("domain or effects should be passed");
      if ("some" !== i && "every" !== i) throw new TypeError("strategy parameter \"of\" can be \"every\" or \"some\". Passed: \"".concat(i, "\""));
      var s = null != o ? o : [];
      var u = n[i];
      a && (s = [], a.onCreateEffect(function (e) {
        return s.push(e);
      }));
      return (0, r.default.combine)({
        and: [s.map(function (e) {
          return e.pending;
        }), u, {
          skipVoid: !1
        }],
        or: {
          sid: "a4upb3"
        }
      });
    };
    var n = {
      some: function some(e) {
        return e.some(Boolean);
      },
      every: function every(e) {
        return e.every(Boolean);
      }
    };
  }),
      j = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.previous = function () {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }

      var t = e[0],
          n = e.length < 2 ? null : e[1];
      if (!r.default.is.store(t, {
        sid: "mzq5dc"
      })) throw Error("previous first argument should be a store");
      var o = (0, r.default.createStore)(n, {
        and: {
          serialize: "ignore",
          skipVoid: !1
        },
        name: "$prevValue",
        sid: "e05yob"
      });
      return t.graphite.seq.push(r.default.step.compute({
        fn: function fn(e, t, n) {
          return (0, r.default.launch)({
            target: o,
            params: n.a,
            defer: !0
          }), e;
        }
      })), o;
    };
  }),
      _ = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.readonly = function (e) {
      if (!r.default.is.targetable(e)) return e;
      if (r.default.is.store(e, {
        sid: "-kqkmsc"
      })) return e.map(function (e) {
        return e;
      }, {
        skipVoid: !1
      });
      if (r.default.is.event(e, {
        sid: "-kodgew"
      })) return e.map(function (e) {
        return e;
      });
      return e;
    };
  }),
      $ = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reset = function (_ref22) {
      var e = _ref22.clock,
          t = _ref22.target;
      var n = Array.isArray(t) ? t : [t],
          o = Array.isArray(e) ? e : [null != e ? e : (0, r.default.createEvent)({
        name: "clocks",
        sid: "bqmea5"
      })];
      return n.forEach(function (e) {
        e.reset(o);
      }), void 0 === e ? o[0] : void 0;
    };
  }),
      E = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reshape = function (_ref23) {
      var e = _ref23.source,
          t = _ref23.shape;
      var n = {};

      var _loop2 = function _loop2(_r2) {
        if (!Object.prototype.hasOwnProperty.call(t, _r2)) return "continue";
        var o = t[_r2];
        n[_r2] = e.map(function (e) {
          var t = o(e);
          return void 0 === t ? null : t;
        }, {
          skipVoid: !1
        });
      };

      for (var _r2 in t) {
        var _ret = _loop2(_r2);

        if (_ret === "continue") continue;
      }

      return n;
    };
  }),
      M = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.snapshot = function (_ref24) {
      var e = _ref24.source,
          t = _ref24.clock,
          _ref24$fn = _ref24.fn,
          n = _ref24$fn === void 0 ? function (e) {
        return e;
      } : _ref24$fn;
      var o = n(e.defaultState),
          a = t ? (0, r.default.sample)({
        and: [{
          source: e,
          clock: t,
          fn: n
        }],
        or: {
          name: "onSnapshot",
          sid: "-imuiws"
        }
      }) : (0, r.default.sample)({
        and: [{
          source: e,
          fn: n
        }],
        or: {
          name: "onSnapshot",
          sid: "-imaqbf"
        }
      }),
          i = (0, r.default.createStore)(o, {
        name: "$snapshot",
        sid: "-63s6pn"
      });
      return i.on(a, function (e, t) {
        return t;
      }), i;
    };
  }),
      O = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.some = function (e, t) {
      var n,
          o = [],
          a = function a() {
        return !1;
      };

      Array.isArray(e) ? (o = e, a = t) : Array.isArray(e.stores) && (o = e.stores, a = e.predicate);
      i = a, n = "function" == typeof i ? a : r.default.is.store(a, {
        sid: "zbwu0l"
      }) ? a.map(function (e) {
        return function (t) {
          return e === t;
        };
      }, {
        skipVoid: !1
      }) : function (e) {
        return e === a;
      };
      var i;
      var s = (0, r.default.combine)({
        and: [o],
        or: {
          name: "$values",
          sid: "-kx24vm"
        }
      }),
          u = n;
      return (0, r.default.combine)({
        and: [u, s, function (e, t) {
          return t.some(e);
        }, {
          skipVoid: !1
        }],
        or: {
          sid: "-ee8kph"
        }
      });
    };
  }),
      P = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.splitMap = function (_ref25) {
      var e = _ref25.source,
          t = _ref25.cases;
      var n = {};
      var o = r.default.is.store(e, {
        name: "current",
        sid: "-htjkz7"
      }) ? e.updates : e;

      for (var _e9 in t) {
        if (_e9 in t) {
          (function () {
            var r = t[_e9];
            n[_e9] = o.filterMap(r), o = o.filter({
              fn: function fn(e) {
                return !r(e);
              }
            });
          })();
        }
      }

      return n.__ = o, n;
    };
  }),
      S = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.spread = function (e) {
      var t = function (e) {
        return Object.keys(e).some(function (t) {
          return !["targets", "source"].includes(t) && r.default.is.unit(e[t]);
        });
      }(e) ? {
        targets: e
      } : e,
          o = t.targets,
          _t$source = t.source,
          a = _t$source === void 0 ? (0, r.default.createEvent)({
        name: "source",
        sid: "e9ipnn"
      }) : _t$source;

      var _loop3 = function _loop3(_e10) {
        if (i = o, s = _e10, n.call(i, s)) {
          var _t8 = o[_e10],
              _n6 = (0, r.default.sample)({
            and: [{
              source: a,
              batch: !1,
              filter: function filter(t) {
                return "object" == _typeof(t) && null !== t && _e10 in t;
              }
            }],
            or: {
              name: "hasTargetKey",
              sid: "eapc0z"
            }
          });

          (0, r.default.sample)({
            and: [{
              batch: !1,
              clock: _n6,
              fn: function fn(t) {
                return t[_e10];
              },
              target: _t8
            }],
            or: {
              sid: "mkzcy4"
            }
          });
        }
      };

      for (var _e10 in o) {
        _loop3(_e10);
      }

      var i, s;
      return a;
    };
    var n = {}.hasOwnProperty;
  }),
      T = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.status = function (e) {
      var _ref26 = r.default.is.effect(e, {
        sid: "cn6w5b"
      }) ? {
        effect: e
      } : e,
          t = _ref26.effect,
          _ref26$defaultValue = _ref26.defaultValue,
          n = _ref26$defaultValue === void 0 ? "initial" : _ref26$defaultValue,
          o = (0, r.default.createStore)(n, {
        name: "$status",
        sid: "ph7d4u"
      });

      if (!r.default.is.effect(t, {
        sid: "-kp39vu"
      })) throw TypeError('status: "effect" property is not an effect');
      return o.on(t, function () {
        return "pending";
      }).on(t.done, function () {
        return "done";
      }).on(t.fail, function () {
        return "fail";
      }), o;
    };
  }),
      x = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.throttle = function () {
      var t = 2 === arguments.length ? {
        source: arguments.length <= 0 ? undefined : arguments[0],
        timeout: arguments.length <= 1 ? undefined : arguments[1]
      } : arguments.length <= 0 ? undefined : arguments[0],
          n = t.source,
          o = t.timeout,
          _t$target3 = t.target,
          a = _t$target3 === void 0 ? (0, r.default.createEvent)({
        name: "target",
        sid: "-gyhb56"
      }) : _t$target3;
      if (!r.default.is.unit(n)) throw new TypeError("source must be unit from effector");

      var i = function (e) {
        if (r.default.is.store(e, {
          sid: "-gj92sk"
        })) return e;

        if ("number" == typeof e) {
          if (e < 0 || !Number.isFinite(e)) throw new Error("timeout must be positive number or zero. Received: \"".concat(e, "\""));
          return (0, r.default.createStore)(e, {
            and: {
              name: "$timeout"
            },
            sid: "-2ktcsz"
          });
        }

        throw new TypeError("timeout parameter should be number or Store. \"".concat(_typeof(e), "\" was passed"));
      }(o),
          s = (0, r.default.createEffect)({
        name: "throttle(".concat(n.shortName || n.kind, ") effect"),
        handler: function handler(e) {
          return new Promise(function (t) {
            return setTimeout(t, e);
          });
        }
      }, {
        name: "timerFx",
        sid: "-lp5bot"
      }),
          u = (0, r.default.createStore)(null, {
        and: {
          serialize: "ignore",
          skipVoid: !1
        },
        name: "$payload",
        sid: "w71tnu"
      }).on(n, function (e, t) {
        return t;
      }),
          d = (0, r.default.createEvent)({
        name: "triggerTick",
        sid: "-dquigt"
      }),
          c = (0, r.default.createStore)(!0, {
        and: {
          serialize: "ignore"
        },
        name: "$canTick",
        sid: "e2dxhp"
      }).on(d, function () {
        return !1;
      }).on(a, function () {
        return !0;
      });

      return (0, r.default.sample)({
        and: [{
          clock: n,
          filter: c,
          target: d
        }],
        or: {
          sid: "-hifwv4"
        }
      }), (0, r.default.sample)({
        and: [{
          source: i,
          clock: d,
          target: s
        }],
        or: {
          sid: "-h3lgud"
        }
      }), (0, r.default.sample)({
        and: [{
          source: u,
          clock: s.done,
          target: a
        }],
        or: {
          sid: "-h0apa7"
        }
      }), a;
    };
  }),
      q = o(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.time = function (e) {
      var t = r.default.is.unit(e) ? {
        clock: e
      } : e,
          o = t.clock,
          a = t.getNow,
          i = t.initial,
          s = null != a ? a : n,
          u = (0, r.default.createEffect)(s, {
        name: "readNowFx",
        sid: "ito90c"
      }),
          d = (0, r.default.restore)(u, null != i ? i : s(), {
        name: "$time",
        sid: "-k3vl4d"
      });
      return (0, r.default.sample)({
        and: [{
          clock: o,
          target: u
        }],
        or: {
          sid: "rul0o2"
        }
      }), d;
    };

    var n = function n() {
      return Date.now();
    };
  }),
      A = a.and,
      z = i.combineEvents,
      V = s.condition,
      N = u.debounce,
      F = d.debug,
      C = c.delay,
      D = l.either,
      I = f.empty,
      R = m.equals,
      B = p.every,
      K = y.format,
      G = g.inFlight,
      H = h.interval,
      J = b.not,
      L = v.once,
      Q = k.or,
      U = w.pending,
      W = j.previous,
      X = _.readonly,
      Y = $.reset,
      Z = E.reshape,
      ee = M.snapshot,
      te = O.some,
      ne = P.splitMap,
      re = S.spread,
      oe = T.status,
      ae = x.throttle,
      ie = q.time,
      se = {
    and: A,
    combineEvents: z,
    condition: V,
    debounce: N,
    debug: F,
    delay: C,
    either: D,
    empty: I,
    equals: R,
    every: B,
    format: K,
    inFlight: G,
    interval: H,
    not: J,
    once: L,
    or: Q,
    pending: U,
    previous: W,
    readonly: X,
    reset: Y,
    reshape: Z,
    snapshot: ee,
    some: te,
    splitMap: ne,
    spread: re,
    status: oe,
    throttle: ae,
    time: ie
  };

  e.and = A, e.combineEvents = z, e.condition = V, e.debounce = N, e.debug = F, e.default = se, e.delay = C, e.either = D, e.empty = I, e.equals = R, e.every = B, e.format = K, e.inFlight = G, e.interval = H, e.not = J, e.once = L, e.or = Q, e.pending = U, e.previous = W, e.readonly = X, e.reset = Y, e.reshape = Z, e.snapshot = ee, e.some = te, e.splitMap = ne, e.spread = re, e.status = oe, e.throttle = ae, e.time = ie, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});